module.exports = __webpack_public_path__ + "img/fuel-uber.0a8edd95.jpg";